// @ts-ignore
import Masonry from 'masonry-layout';
// @ts-ignore
import ImagesLoaded from 'imagesloaded';

export class ImageGallery {
    galleries: NodeListOf<HTMLElement>;

    constructor() {
        this.galleries = document.querySelectorAll('[data-image-gallery]');
        if (this.galleries.length === 0) {
            return;
        }
        this.init();
    }

    init() {
        this.addTriggerEvents();
    }

    addTriggerEvents() {
        this.galleries.forEach((gallery) => {
            const msnry = new Masonry(gallery, {
                itemSelector: "[data-image-gallery-item]",
                columnsWidth: "[data-image-gallery-item]",
                percentPosition: true,
                originTop: true
            });
            ImagesLoaded('[data-image-gallery]', () => {
                msnry.layout();
            });
        });
    }

}
document.addEventListener("DOMContentLoaded", function() {
    new ImageGallery();
});
